export default {
  "path": "/demo/charts",
  "meta": {
    "name": "demo-Charts Demo",
    "title": "Charts Demo",
    "isComponentDoc": true,
    "category": "Charts"
  }
};